import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  Signal,
} from '@angular/core';
import {
  ExternalLinkComponent,
  Icon,
  IconComponent,
  ImageThumbnailComponent,
  ImageThumbnailUnsupportedComponent,
  PrimengButtonDirective,
  SvgIcon,
} from '@web/shared/ui';
import { CssClass, isNotNil, Nillable } from '@web/utils';
import { SummernoteHtmlPreviewComponent } from '@web/shared/external';
import { BrandSocialMediaIconComponent } from '../brand-social-media-icon/brand-social-media-icon.component';
import { BrandSocialMediaIconByCodePipe } from '../../pipes/brand-social-media-icon-by-code.pipe';
import { AsyncPipe, NgClass, NgOptimizedImage } from '@angular/common';
import { Button } from 'primeng/button';
import { BrandSocialMedia } from '@web/shared/module/brand';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-brand-details',
  imports: [
    SummernoteHtmlPreviewComponent,
    ExternalLinkComponent,
    BrandSocialMediaIconComponent,
    BrandSocialMediaIconByCodePipe,
    AsyncPipe,
    Button,
    PrimengButtonDirective,
    ImageThumbnailComponent,
    NgClass,
    NgOptimizedImage,
    IconComponent,
    TooltipModule,
    ImageThumbnailUnsupportedComponent,
  ],
  templateUrl: './brand-details.component.html',
  styleUrl: './brand-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandDetailsComponent {
  public readonly stickyImage = input<boolean>(false);
  public readonly stickyImageTopCssClass = input<string>('top-0');
  public readonly name = input.required<string>();
  public readonly description = input<Nillable<string>>();
  public readonly homeUrl = input<Nillable<string>>();
  public readonly socials = input<Nillable<BrandSocialMedia[]>>([]);
  public readonly illustrationSrc = input<Nillable<string>>();
  public readonly illustrationAlt = input<Nillable<string>>();
  public readonly shouldShowEditButton = input<boolean>(false);
  public readonly shouldShowStatusInfo = input<boolean>(false);
  public readonly isPrivate = input<boolean>(false);
  public readonly isPublic = input<boolean>(false);
  public readonly isDraft = input<boolean>(false);

  public readonly editClickEvent = output<void>();

  protected readonly Icon = Icon;
  protected readonly SvgIcon = SvgIcon;
  protected readonly stickyImageCssClass = this.stickyImageCssClassSignal();
  protected readonly isNotNil = isNotNil;

  public handleEditClick(): void {
    this.editClickEvent.emit();
  }

  private stickyImageCssClassSignal(): Signal<CssClass> {
    return computed(() => {
      if (this.stickyImage()) {
        return {
          sticky: true,
          [this.stickyImageTopCssClass()]: true,
        };
      }

      return {};
    });
  }
}
